<script>
import 'vue-select/dist/vue-select.css'
import { required } from 'vuelidate/lib/validators'
import { axiosGetPost } from '@router/axiosGetPost'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { formatDate, parseDate } from '@router/date-utils'

export default {
  name: 'EditDateRange',
  props: {
    idsSeleted: [Object, Array],
  },
  components: {
    DateRangePicker,
  },
  data() {
    return {
      validation: [],
    }
  },
  validations: {
    validation: { required },
  },
  computed: {},
  created() {
    const currentDate = new Date()
    this.validation = {
      startDate: currentDate,
      endDate: currentDate,
    }
  },
  mounted() {},
  methods: {
    validate_fields() {
      let response = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toastr.e('Field is required')
        response = false
      }
      return response
    },
    updateLocal() {
      if (this.validate_fields()) {
        let date = formatDate(this.validation)
        this.loadingData = true
        axiosGetPost('post', '/localCharges/updateDateGLocal', {
          data: {
            ids: this.idsSeleted,
            validation: date,
          },
        }).then((response) => {
          this.loadingData = false
          console.log(response)
          if (response.success) {
            if (response.real_time) {
              this.$toastr.s('Date "' + date + '" Updated')
              this.$emit('closeModal')
            } else {
              this.$toastr.s('Date "' + date + '" Update in background')
              this.$emit('closeModal')
            }
          } else {
            this.errorShow = true
            this.error = 'Error to save'
          }
          return response
        })
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="col-12">
      <div class="form-group row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label>Validation</label>
          <date-range-picker
            opens="center"
            :locale-data="{
              format: 'yyyy-mm-dd',
              separator: ' / ',
              direction: 'ltr',
            }"
            class="col-md-12"
            v-model="validation"
            timezone="local"
          >
          </date-range-picker>
          <div v-if="$v.validation.$error" style="color: red">
            * This value is required.
          </div>
        </div>
        <div class="col-md-5">
          <label>Data</label>
          <div class="m-2">
            {{ idsSeleted.length }} - Globalchargers selected
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center mt-3">
          <b-button variant="primary" class="col-4" @click="updateLocal"
            >Submit</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>